// src/hooks/usePermission.js
import {useAuthStore} from "@/stores/auth";

export function usePermission() {
  const authStore = useAuthStore();

  // 用户已有的权限标识（比如 ['goods-add', 'goods-del']）
  const userActions = authStore.user.permissions || []

  const hasPermission = (value) => {
    if (!value) return false

    // value 可能是 ["goods-add", "goods-export"]
    const needed = Array.isArray(value) ? value : [value]

    return needed.some(item => userActions.includes(item))
  }

  return {
    hasPermission
  }
}
